import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { EnvironmentLoader } from './environments/utils/environment-loader.util';

async function bootstrapApp() {
  await EnvironmentLoader.loadEnvironment();

  const env = EnvironmentLoader.environment;

  if (env && env.production) {
    enableProdMode();
  }

  platformBrowserDynamic()
    .bootstrapModule(AppModule)
    .catch((err) => console.error(err));
}

bootstrapApp();
